import { useEffect, useState } from "react";

import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { InputDecimal } from "@/components/ui/input-decimal";
import { Label } from "@/components/ui/label";

import { comImposto, reais } from "../api";

const MUDANCA_GRANDE = 0.3;   // acima disso a Meta pode voltar a "aprender" quem compra

/** Mudar o valor por semana de uma campanha no ar. Vale para o tempo que falta. */
export default function DialogoValor({ campanha, impostoPct, aoFechar, aoSalvar }) {
  const atual = campanha?.orcamento_semanal_centavos || 0;
  const [valor, setValor] = useState("");
  const [salvando, setSalvando] = useState(false);
  useEffect(() => { if (campanha) setValor(String(atual / 100)); }, [campanha, atual]);
  if (!campanha) return null;

  const novo = Math.round((Number(valor) || 0) * 100);
  const mudou = novo > 0 && novo !== atual;
  const grande = mudou && atual > 0 && Math.abs(novo - atual) / atual > MUDANCA_GRANDE;
  const salvar = async () => {
    setSalvando(true);
    const ok = await aoSalvar(novo);
    setSalvando(false);
    if (ok) aoFechar();
  };

  return (
    <Dialog open onOpenChange={(aberto) => !aberto && aoFechar()}>
      <DialogContent data-e2e="dialogo-valor">
        <DialogHeader>
          <DialogTitle>Valor por semana</DialogTitle>
          <DialogDescription>Hoje: {reais(atual)} por semana. O valor novo vale para o tempo que falta; o que já foi gasto não muda.</DialogDescription>
        </DialogHeader>
        <div>
          <Label>Novo valor por semana</Label>
          <div className="mt-1 flex items-center gap-2">
            <span className="text-muted-foreground text-sm">R$</span>
            <div className="w-40"><InputDecimal decimals={2} value={valor} onChange={setValor} autoFocus data-e2e="dialogo-valor-campo" /></div>
          </div>
          <p className="text-[11px] text-muted-foreground mt-1.5">Com o imposto ({Number(impostoPct || 0).toLocaleString("pt-BR")}%): {reais(comImposto(novo, impostoPct))} por semana.</p>
          {grande && (
            <p className="text-xs text-amber-600 rounded-lg bg-amber-500/10 px-3 py-2 mt-2" data-e2e="dialogo-valor-aviso">
              Mudança de mais de 30%. Aumente aos poucos: mudança grande pode fazer a Meta recomeçar o aprendizado de quem compra.
            </p>
          )}
        </div>
        <DialogFooter>
          <button type="button" onClick={aoFechar} className="h-10 px-4 rounded-lg border text-sm font-medium hover:bg-muted">Cancelar</button>
          <button type="button" onClick={salvar} disabled={!mudou || salvando} data-e2e="dialogo-valor-salvar"
            className="h-10 px-5 rounded-lg bg-primary text-primary-foreground text-sm font-semibold disabled:opacity-50">
            {salvando ? "Salvando…" : "Salvar valor"}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
